export class PostPriorityLevelsHttp{
    static async getAll() {
        try {
            return await window.axios.get(`post-priority-levels`)
        } catch (err) {
            return Promise.reject(err);
        }
    }
}